import React from "react";
import { SEO, MainLayout, PriceQuotation } from "../../../../components";
const PriceQuotationPage = () => {
  return (
    <>
      <SEO title="price quotation" />
      <MainLayout>
        <PriceQuotation />
      </MainLayout>
    </>
  );
};

export default PriceQuotationPage;
